import { useState } from 'react';
import { useDb } from '@/lib/store';
import { readableOn } from '@/lib/color';

/** The workspace's uploaded logo, or the first letter of its name on its color. */
export function WorkspaceLogo({ workspaceId, size = 20 }: { workspaceId: string; size?: number }) {
  const ws = useDb((db) => db.workspaces[workspaceId]);
  const color = ws?.color ?? '#7b68ee';
  const [failed, setFailed] = useState<string | null>(null);
  const radius = Math.max(4, Math.round(size * 0.24));
  if (ws?.logoUrl && failed !== ws.logoUrl)
    return <img className="ws-logo ws-logo-img" src={ws.logoUrl} alt="" draggable={false} style={{ width: size, height: size, borderRadius: radius }} onError={() => setFailed(ws.logoUrl ?? null)} />;
  return (
    <span
      className="ws-logo"
      style={{ width: size, height: size, background: color, color: readableOn(color), fontSize: Math.round(size * 0.5), borderRadius: radius }}
    >
      {(ws?.name ?? 'W').trim()[0]?.toUpperCase()}
    </span>
  );
}

export function SpaceAvatar({ spaceId, size = 18 }: { spaceId: string; size?: number }) {
  const space = useDb((db) => db.spaces[spaceId]);
  const color = space?.color ?? '#87909e';
  if (space?.icon && !/^[A-Z][A-Za-z0-9]+$/.test(space.icon)) {
    return (
      <span className="space-avatar emoji" style={{ width: size, height: size, fontSize: Math.round(size * 0.78) }}>
        {space.icon}
      </span>
    );
  }
  return (
    <span className="space-avatar" style={{ width: size, height: size, background: color, color: readableOn(color), fontSize: Math.round(size * 0.58) }}>
      {(space?.name ?? 'S').trim()[0]?.toUpperCase()}
    </span>
  );
}
